import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React, { useContext } from "react";

import {
  Context,
  fetchCareerLatestSheet,
  markCareerFeedbackSheetAsRead,
  fetchCareerFeedbackSheets,
} from "../../../store/student";
import LoginHeader from "../../../organisms/LoginHeader";
import CareerMap from "../../../templates/CareerMap";
import styles from "../common.module.scss";

const CareerMapPage = () => {
  const { dispatch } = useContext(Context);

  useIonViewWillEnter(() => {
    dispatch(fetchCareerLatestSheet());
    dispatch(fetchCareerFeedbackSheets());
    dispatch(markCareerFeedbackSheetAsRead());
  }, [dispatch]);

  return (
    <IonPage>
      <LoginHeader title="キャリア開拓モード" unreadNotiCount={0} />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <CareerMap />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CareerMapPage;
